import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { concatMap, tap } from "rxjs/operators";
import { AuthService } from "src/app/core/authentication/auth.service";
import { ExcelService } from "src/app/core/services/documentos/excel.service";
import { SolicudesAsignadasService } from "src/app/core/services/solicitudesAsignadas/solicudes-asignadas.service";
import { UserService } from "src/app/core/services/user/user.service";
import {
  User,
} from "src/app/shared/models/sst/solicitudes";

@Component({
  selector: 'app-report-ssta-tiempo-programadores-transportistas',
  templateUrl: './report-ssta-tiempo-programadores-transportistas.component.html',
  styleUrls: ['./report-ssta-tiempo-programadores-transportistas.component.scss']
})
export class ReportSstaTiempoProgramadoresTransportistasComponent implements OnInit {

  reportSst: any[] = [];

  users: User[] = [];

  statuses: any[];

  querySolicitud: any[] = [];

  programadores: User[] = [];

  cols: any[] = [];

  spinner = true;

  rol: string;

  roles: string[] = [];

  constructor(
    private userService: UserService,
    private messageService: MessageService,
    private authService: AuthService,
    private excelService: ExcelService,
    private solicitudesAsignadas: SolicudesAsignadasService
  ) {
  }

  ngOnInit(): void {
    this.getData().subscribe({
      complete: () => {
        this.spinner = false;
      }
    });
  }

  getData() {
    return this.authService.actual().pipe(
      tap({
        next: (data) => {
          this.roles = data.rolenames
        }, error: (error) => {
          this.messageService.add({
            key: "msg",
            severity: "error",
            summary: "Error",
            detail: error.error ? error.error.message : "Ups! ocurrio un error",
          });
        },
        complete: () => {
        }
      }),
      concatMap(() => this.getProgramadores()),
      concatMap(() => this.reporteSstaTiempoPromedioPorProgramadorHastaAsignacionPorTransportista()),
    )
  }

  getProgramadores() {
    return this.userService.getByRol("PROGRAMADOR").pipe(
      tap({
        next: (data) => {
          data.forEach((e) => {
            if (e.azure) {
              this.programadores.push({ name: e.username, code: e.id });
            } else {
              this.programadores.push({
                name: (e.companyName || e.username),
                code: e.id,
              });
            }
          });
        },
        error: (error) => {
          this.messageService.add({
            key: "msg",
            severity: "error",
            summary: "Error",
            detail: error.error ? error.error.message : "Ups! ocurrio un error",
          });
        }
      }))
  }


  reporteSstaTiempoPromedioPorProgramadorHastaAsignacionPorTransportista() {
   return this.solicitudesAsignadas
      .reporteSstaTiempoPromedioPorProgramadorHastaAsignacionPorTransportista(this.querySolicitud)
      .pipe(
        tap({
          next: (data) => {
            this.users = data;

          },
          error: (error) => {
            this.messageService.add({
              key: "msg",
              severity: "error",
              summary: "Error",
              detail: error.error ? error.error.message : "Ups! ocurrio un error",
            });
          }
        })
      )
  }

  programador = "";
  minDateValue = new Date();
  startDateSolicitud = "";
  endDateSolicitud = ""

  filtrosSolicitud() {
    this.querySolicitud = [];

    if (this.startDateSolicitud) {
      this.minDateValue = new Date(this.startDateSolicitud);
    }

    if (this.startDateSolicitud && this.endDateSolicitud) {
      this.querySolicitud.push({
        col: "startDate",
        value: this.startDateSolicitud,
      });
      this.querySolicitud.push({
        col: "endDate",
        value: this.endDateSolicitud,
      });
    }

    if (this.programador) {
      this.querySolicitud.push({
        col: "programmerId",
        value: this.programador,
      });
    }
    if (this.querySolicitud.length > 0) {
      this.spinner = true;
    }
    this.reporteSstaTiempoPromedioPorProgramadorHastaAsignacionPorTransportista().subscribe({
      complete: () => {
        this.spinner = false;
      }
    });
  }


  descargarExcel() {
    this.excelService.descargarTiempoPromedioPorProgramadorHastaAsignacionPorTransportista(this.querySolicitud).subscribe(
      (data) => {
        var downloadURL = URL.createObjectURL(data);
        var link = document.createElement("a");
        link.href = downloadURL;
        link.download = `reporte-programador-hasta-asignacion-transportista-SST.xlsx`;
        link.click();
      },
      (error) => {
        this.messageService.add({
          key: "msg",
          severity: "error",
          summary: "Error",
          detail: error.error ? error.error.message : "Ups! ocurrio un error",
        });
      }
    );
  }

  hasRole(role: string) {
    return this.roles.indexOf(role) !== -1;
  }
}
